import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
    standalone: true,
    selector: 'p-splitter-area',
    template: '<ng-content></ng-content>',
    styleUrls: ['./p-splitter-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PSplitterAreaComponent {
    @Input() size = 50;
    @Input() minSize = 0;
    @Input() maxSize = 100;

    @Input() set visible(value: boolean) {
        if (this._visible !== value) {
            this._visible = value;
            this.visibilityChange.emit(value);
            this.cdr.markForCheck();
        }
    }
    get visible(): boolean {
        return this._visible;
    }

    @HostBinding('class.p-splitter-area--hidden')
    get isHiddenClass(): boolean {
        return !this._visible;
    }

    @HostBinding('attr.aria-hidden')
    get ariaHidden(): string | null {
        return this._visible ? null : 'true';
    }

    @Output() readonly visibilityChange = new EventEmitter<boolean>();
    @Output() readonly sizeChange = new EventEmitter<number>();

    private _visible = true;

    constructor(
        public readonly elementRef: ElementRef<HTMLElement>,
        private readonly cdr: ChangeDetectorRef
    ) {}
}
